import type { PollOption, QuestionItemType, QuizItemQuestion } from './types';

const DEFAULT_ITEM_TYPE: QuestionItemType = 'trivia';

export function resolveItemType(question: QuizItemQuestion | null | undefined): QuestionItemType {
  if (!question) return DEFAULT_ITEM_TYPE;
  return question.item_type === 'poll' ? 'poll' : DEFAULT_ITEM_TYPE;
}

export function isPollItem(question: QuizItemQuestion | null | undefined): boolean {
  return resolveItemType(question) === 'poll';
}

export function isTriviaItem(question: QuizItemQuestion | null | undefined): boolean {
  return !isPollItem(question);
}

export function getItemPrompt(question: QuizItemQuestion): string {
  if (isPollItem(question)) {
    return question.poll_prompt?.trim() || question.stem?.trim() || '';
  }
  return question.stem?.trim() || '';
}

export function getPollOptions(question: QuizItemQuestion): PollOption[] {
  if (!isPollItem(question) || !Array.isArray(question.poll_options)) {
    return [];
  }
  return [...question.poll_options].sort((a, b) => a.sort_index - b.sort_index);
}

/** Stable key for React lists when the local quiz question_id is only an ordinal. */
export function getGameplayQuestionKey(question: QuizItemQuestion): string {
  if (question.edition_item_id) {
    return `ei-${question.edition_item_id}`;
  }
  if (typeof question.question_id === 'number' && question.question_id > 0) {
    return `q-${question.question_id}`;
  }
  if (question.poll_definition_id) {
    return `poll-${question.poll_definition_id}`;
  }
  return `idx-${question.question_index ?? 0}`;
}

export function canLogTriviaAnswer(question: QuizItemQuestion | null | undefined): boolean {
  return isTriviaItem(question) && typeof question?.question_id === 'number';
}
